var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9024 0C26.048 0 28.112 0.942222 29.6304 2.63289C31.1504 4.32 32 6.59556 32 8.97778V23.0222C32 27.9822 28.368 32 23.9024 32H8.096C3.6304 32 0 27.9822 0 23.0222V8.97778C0 4.01778 3.6144 0 8.096 0H23.9024ZM26.4494 11.6281L26.5774 11.4859C26.9598 10.9704 26.9598 10.2237 26.5598 9.70815C26.3374 9.44326 26.0318 9.28148 25.7134 9.24593C25.3774 9.22637 25.0574 9.35259 24.8158 9.60148L17.6014 16.0015C16.6735 16.8566 15.3439 16.8566 14.4015 16.0015L7.20145 9.60148C6.70385 9.19259 6.01585 9.24593 5.60145 9.72593C5.16945 10.2059 5.12145 10.9704 5.48785 11.5037L5.69745 11.7348L12.9774 18.0459C13.8734 18.8281 14.9598 19.2548 16.0975 19.2548C17.2318 19.2548 18.3374 18.8281 19.2318 18.0459L26.4494 11.6281Z",
    fill: "#1D619D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.c4b842def64b12b5cc13850925271ba8.svg";
export { ForwardRef as ReactComponent };